import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {
  name = 'Dancekids Studio'
  shortName = 'Dancekids'
  phone: number | null = null
  add1 = '726 E. Main St'
  add2 = 'Lebanon, OH 45036'
  emailBase = '@DancekidsOhio.com'
  registrationLink = 'https://app.jackrabbitclass.com/regv2.asp?id=541265&amp;hc=&amp;initEmpty=&amp;hdrColor=&amp;WL=0&amp;'
  fullEmailPaths = [
    { name: 'Cathy', title: 'Owner/Director' },
    { name: 'Manny', title: 'Owner/Director' },
    { name: 'Staff', title: 'General Staff Email' }
  ]
  emailPaths = [
    { name: 'Cathy', title: 'Owner/Director' },
    { name: 'Manny', title: 'Owner/Director' }
  ]
  mapLocation = 'https://goo.gl/maps/hLYd9HAWmV2HxtPa9'
  instagram = 'https://www.instagram.com/dancekidsstudio/'
  facebook = 'https://www.facebook.com/DancekidsStudioLebanon'

  getPhone = (): number | null => {
    return this.phone;
  }

  getPhoneFormatted = (phonePassed?: number): string | null => {
    let providedNumber
    if (phonePassed) {
      providedNumber = phonePassed
    } else {
      providedNumber = this.phone
    }
    if (providedNumber) {
      return `(${providedNumber.toString().slice(0, 3)}) ${providedNumber.toString().slice(3, 6)}-${providedNumber.toString().slice(6, 10)}`
    }
    return null
  }

  getAddress = (): Array<string> | null => {
    if (this.add1) {
      return [this.add1, this.add2]
    }
    return null
  }

  getEmail = (spec?: string): string => {
    let specEmail = `Contact${this.emailBase}`
    if (spec) {
      this.fullEmailPaths.forEach(path => {
        if (Object.values(path).includes(spec)) {
          specEmail = `${spec}${this.emailBase}`
        }
      })
    }
    return specEmail
  }

  getMapLocation = (): string => {
    return this.mapLocation
  }
}
